module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbjl-box"
  }, [_c('div', {
    staticClass: "zbjl-box-container"
  }, [_c('div', {
    staticClass: "zbjl-mask-model-rect-user"
  }, [_c('div', {
    staticClass: "zbjl-mask-model-rect-user-left"
  }, [_c('img', {
    staticClass: "zbjl-mask-model-rect-user-left-img",
    attrs: {
      "src": _vm.data.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbjl-mask-model-rect-user-content"
  }, [_c('span', {
    staticClass: "zbjl-mask-model-rect-user-content-span"
  }, [_vm._v(_vm._s(_vm.data.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "zbjl-mask-model-rect-user-content-span1"
  }, [_vm._v("ID：" + _vm._s(_vm.data.recodeCode))])])]), _vm._v(" "), _c('img', {
    staticClass: "zbjl-mask-model-rect-user-img",
    attrs: {
      "src": require("../../assets/image/tanchuang_x_b@2x.png"),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleCloseZbjl
    }
  })]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "zbjl-mask-model-rect-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "zbjl-mask-model-rect-list-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('zbjlItem', {
      key: index,
      attrs: {
        "data": item
      }
    })
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a41fa3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/zhibojilu/zhibojilu.vue
// module id = 1025
// module chunks = 1